/* ============================================================

   ============================================================ */
(function () {
  'use strict';

  function init() {
    var actions = document.querySelector('.ctf-header .ctf-header-actions');
    if (!actions) return;
    if (actions.querySelector('.ctf-search-trigger')) return; // ya inyectado

    // --- Estilos mobile (van después de los del theme: misma
    //     especificidad + !important les gana a los display:none) ---
    var style = document.createElement('style');
    style.textContent =
      '.ctf-header .ctf-search-trigger{display:none !important;}' +
      '@media (max-width: 767px){' +
        '.ctf-header .ctf-search-trigger{' +
          'display:flex !important;background:none;border:0;cursor:pointer;' +
        '}' +
        '.ctf-header .ctf-btn--buy{' +
          'display:inline-flex !important;align-items:center;' +
          'background:#39f686;color:#111;border:0;border-radius:60px;' +
          'padding:7px 14px;font-size:12px;font-weight:700;' +
          'line-height:1;text-decoration:none;white-space:nowrap;' +
        '}' +
        '.ctf-header .ctf-header-actions{gap:6px;}' +
      '}';
    document.head.appendChild(style);

    // --- Botón de búsqueda (primero en las acciones) ---
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ctf-icon-btn ctf-search-trigger';
    btn.setAttribute('aria-label', 'Search products');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" width="20" height="20" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';

    btn.addEventListener('click', function () {
      var toggle = document.querySelector('.ctf-mobile-toggle');
      if (toggle) {
        toggle.click(); // reusa la lógica existente de apertura del menú
        setTimeout(function () {
          var input = document.querySelector('.ctf-mobile-search input[type="search"]');
          if (input) input.focus();
        }, 350); // esperar la transición de apertura
      } else {
        window.location.href = '/search';
      }
    });

    actions.insertBefore(btn, actions.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();